import script from "./message-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-text.vue?vue&type=script&lang=ts&setup=true"

import "./message-text.vue?vue&type=style&index=0&id=50640654&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50640654"]])

export default __exports__